// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"d0849c4e","787":"26d67a7b"}[chunkId] + ".chunk.js";
};